import { Component, ChangeDetectionStrategy, inject, signal, computed } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { DateTime } from 'luxon';
import { ICouponUse, IPackage, sortCouponsByValue } from '../../types';
import { MatListModule } from '@angular/material/list';
import { PaintDirective } from '../../paint.directive';

@Component({
  selector: 'coupon-list',
  templateUrl: './coupon-list.component.html',
  styleUrls: ['./coupon-list.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatListModule, PaintDirective, MatBottomSheetModule, PaintDirective],
})
export class CouponListComponent {
  input = inject<{ uses: ICouponUse[], package: IPackage }>(MAT_BOTTOM_SHEET_DATA);
  reference = inject(MatBottomSheetRef<CouponListComponent>);

  uses = signal<ICouponUse[]>([]);
  package = signal<IPackage|null>(null);

  constructor(){
    this.uses.set(this.input.uses||[]);
    this.package.set(this.input.package||null);
  }

  sorted_uses = computed(() => {
    const pkg = this.package();
    return pkg ? sortCouponsByValue(pkg, this.uses()) : [];
  });

  parsed_uses = computed(() => {
    const uses = this.sorted_uses();

    return uses.map(use => {
      return {
        _id: use._id,
        code: use.code,
        free_days: use.coupon.free_days,
        discount: this.discountString(use),
        price: this.priceString(use),
        expiry: this.expiryString(use)
      }
    });
  });

  select(code: string){
    this.reference.dismiss(code);
  }

  discountString(use: ICouponUse){
    if(!use || !use.coupon) return '???';

    if(use.coupon.percentage){
      return `${use.coupon.reduction.toFixed(0)}%`;
    }else{
      if((use.coupon.reduction.toFixed(0) + '.00') != use.coupon.reduction.toFixed(2)){
        return `€${use.coupon.reduction.toFixed(2)}`;
      }else{
        return `€${use.coupon.reduction.toFixed(0)}`;
      }
    }
  }

  priceString(use: ICouponUse){
    const pkg = this.package();
    if(!use || !use.coupon || !pkg) return '???';

    // console.log(this.allPackages, use.coupon.package);

    const base_price = Number(pkg.price || 0);
    
    if(use.coupon.percentage){
      const percentage = (100-use.coupon.reduction)/100;
      return `€${(base_price * percentage).toFixed(2)}`;
    }else{
      const price = (base_price - use.coupon.reduction);
      
      if((price.toFixed(0) + '.00') != price.toFixed(2)){
        return `€${price.toFixed(2)}`;
      }else{
        return `€${price.toFixed(0)}`;
      }
    }
  }

  expiryString(use: ICouponUse){
    if(!use) return '';

    if(!use.expiry) return '';

    if(DateTime.fromISO(use.expiry).diffNow('day').as('days') < 7){
      return 'Expires Soon';
    }

    return '';

  }

}
